import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import styled from 'styled-components/native'

import { AlertBannerTypes } from '@lyrahealth-inc/shared-app-logic/src/features/alerts/AlertBannerTypes'

import { AlertBanner } from './AlertBanner'
import { TargetIcon } from '../../atoms/icons/TargetIcon'
import { Link } from '../../atoms/link/Link'
import { tID } from '../../utils/utils'

const FixedHeightContainer = styled(View)({
  height: 72,
  overflow: 'hidden',
  justifyContent: 'center',
})

export type ManagerCoachingBannerProps = {
  onExplorePress: () => void
  dismissHandler: () => void
}

export const ManagerCoachingBanner: FunctionComponent<ManagerCoachingBannerProps> = ({
  onExplorePress,
  dismissHandler,
}) => {
  return (
    <FixedHeightContainer>
      <AlertBanner
        show
        style={AlertBannerTypes.NEUTRAL}
        icon={<TargetIcon />}
        testID={tID('ManagerCoachingBanner')}
        contents={
          <FormattedMessage
            defaultMessage='Claim your spot: Manager coaching'
            description='Banner text prompting user to return to the manager coaching microsite'
          />
        }
        trailingLink={
          <Link
            text={
              <FormattedMessage
                defaultMessage='Explore'
                description='Link text to navigate back to the manager coaching microsite'
              />
            }
            onPress={onExplorePress}
            underline
            medium
          />
        }
        dismissHandler={dismissHandler}
      />
    </FixedHeightContainer>
  )
}
